import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
@Component({
    selector: 'label-pane',
    templateUrl: './label-pane.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
            :host {
                display: block;
            }
        `
    ],
    standalone: true
})
export class LabelPaneComponent {
    @Input()
    transparent = false;
}
